import type { FaireProductEntity } from "../../entity_types/product";

export const p_6dfpwgah8x: FaireProductEntity = {
  token: "p_6dfpwgah8x",
  type: "product",
  name: "peony vase mini enclosure notecard",
  brandToken: "b_mmdanrh9jf",
  brandName: "emily lex studio",
  imageUrl:
    "https://cdn.faire.com/fastly/2e70004cbc9bb4fe82879dcd5f098bbd4d3fa65290c74e24f1e90c9b6f3006b0.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/0b92eb408e2aa9e7ab8cc8e34c5ea7c476e813fa55cea1b42cafb01cc0391549.jpeg",
    "https://cdn.faire.com/fastly/9dec1c7fde064c0de84fdc549961fcefbf36c937aaad904d9704db911d0d61d0.jpeg",
    "https://cdn.faire.com/fastly/80029d8e40de659340fc375ccfe1ecda44c5d04be7807ba76827f112cadc3e87.jpeg",
    "https://cdn.faire.com/fastly/c4e037c54ef32cad11b06a7fc1afd3e07929e38e3dfecd4f79ba1f401945a123.jpeg",
    "https://cdn.faire.com/fastly/77cde735bec62ab375f111ef525b13a7368c3631cba4ed1fc74d5ec1ea609b11.jpeg",
  ],
  priceDollars: 3,
  description:
    'A mini notecard for petite greetings. Perfect for adding to a gift or popping in a gift card for a pretty presentation. \n\n\nDetails:\n\n- single card + envelope + sticker for sealing\n- blank inside\n- 2.5" x 3.5"\n- Printed on 120lb superfine paper\n- Original watercolor artwork by Emily Lex\n',
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-28T05:30:08.690Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
